<template>
  <div class="layout">
    <div class="layout_nav">
      <!-- navegacion  -->
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <Welcome v-bind="getUser"></Welcome>
          </v-col>
          <v-col class="pa-0" md="auto">
            <div v-if="getTimerConfig[0] != undefined" class="card_time my-5">
              <UpdateTimer
                :data="itemObjct"
                :visible="newTimeFlag"
                @close="newTimeFlag = false"
              ></UpdateTimer>
              <div class="card_title">
                <p>
                  <v-icon small class="mr-2">mdi-download-network</v-icon>
                  Comunicación API
                </p>
              </div>
              <div class="card_copy">
                <p>Cada, {{ getTimerConfig[0].time }} <span>min</span></p>
              </div>
              <div v-if="isMaster == 1" class="card_btn">
                <v-btn small color="secondary" @click="editItem(getTimerConfig[0])">
                  Actualizar Tiempo
                </v-btn>
              </div>
            </div>
            <Snackbar
              v-bind:visible="getAlert.snackbar"
              v-bind:text="getAlert.text"
            ></Snackbar>
          </v-col>
        </v-row>
      </v-container>
      <v-tabs v-model="tab">
        <v-tab v-if="isZone == 1" key="zone">Zona</v-tab>
        <v-tab v-if="isCycle == 1" key="cycle">Ciclo</v-tab>
        <v-tab v-if="isRoad == 1" key="road">Ruta</v-tab>
        <v-tab v-if="isGroupSocial == 1" key="socialgroup">Estrato</v-tab>
        <v-tab v-if="isPeriod == 1" key="period">Periodo</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-if="isZone == 1" key="zone">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newZoneFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear Zona
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col sm="auto" class="pa-0 py-3">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListZone.active"
                      v-bind:inactive="getListZone.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableZone></TableZone>
            <NewZone
              :visible="newZoneFlag"
              @close="newZoneFlag = false"
            ></NewZone>
          </div>
        </v-tab-item>
        <v-tab-item v-if="isCycle == 1" key="cycle">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newCycleFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear Ciclo
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col sm="auto" class="pa-0 py-3">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListCycle.active"
                      v-bind:inactive="getListCycle.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableCycle></TableCycle>
            <NewCycle
              :visible="newCycleFlag"
              @close="newCycleFlag = false"
            ></NewCycle>
          </div>
        </v-tab-item>
        <v-tab-item v-if="isRoad == 1" key="Road">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newRoadFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear Ruta
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col sm="auto" class="pa-0 py-3">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListRoad.active"
                      v-bind:inactive="getListRoad.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableComp></TableComp>
            <NewRoad
              :visible="newRoadFlag"
              @close="newRoadFlag = false"
            ></NewRoad>
          </div>
        </v-tab-item>
        <v-tab-item v-if="isGroupSocial == 1" key="socialgroup">
          <div>
            <v-container fluid>
              <v-row>
                <v-col class="pa-0">
                  <div class="ctn_btn_new btn_left">
                    <v-btn
                      class="btn_new"
                      @click.stop="newSocialFlag = true"
                      color="primary"
                    >
                      <v-icon>mdi-plus-circle-outline</v-icon>
                      <span>
                        Crear Estrato
                      </span>
                    </v-btn>
                  </div>
                </v-col>
                <v-col sm="auto" class="pa-0 py-3">
                  <div class="ctn_indicator">
                    <!-- indicador -->
                    <Indicator
                      v-bind:active="getListSocialGroup.active"
                      v-bind:inactive="getListSocialGroup.inactive"
                    ></Indicator>
                    <!-- btn crear  -->
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <!-- tabla de datos -->
            <TableSocial></TableSocial>
            <NewSocial
              :visible="newSocialFlag"
              @close="newSocialFlag = false"
            ></NewSocial>
          </div>
        </v-tab-item>
        <v-tab-item v-if="isPeriod == 1" key="period">
          <div>
            <div class="layout_row">
              <div class="layout_colum">
                <div class="ctn_btn_new btn_left">
                  <v-btn
                    class="btn_new"
                    @click.stop="newPeriodFlag = true"
                    color="primary"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                    <span>
                      Crear Periodo
                    </span>
                  </v-btn>
                </div>
              </div>
              <div class="layout_colum">
                <div class="ctn_indicator">
                </div>
              </div>
            </div>
            <!-- tabla de datos -->
            <TablePeriod></TablePeriod>
            <NewPeriod
              :visible="newPeriodFlag"
              @close="newPeriodFlag = false"
            ></NewPeriod>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import Nav from '@/components/Nav.vue'
import TableComp from '@/components/road/Table.vue'
import TableCycle from '@/components/cycle/Table.vue'
import TableZone from '@/components/zone/Table.vue'
import TablePeriod from '@/components/period/Table.vue'
import TableSocial from '@/components/socialgroup/Table.vue'
import Welcome from '@/components/Welcome.vue'
import Indicator from '@/components/Indicator.vue'
import NewRoad from '@/components/road/New.vue'
import NewCycle from '@/components/cycle/New.vue'
import NewZone from '@/components/zone/New.vue'
import NewPeriod from '@/components/period/New.vue'
import NewSocial from '@/components/socialgroup/New.vue'
import UpdateTimer from '@/components/timer/Edit.vue'
import Snackbar from '@/components/Snackbar.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ConfigHome',
  components: {
    Nav,
    TableComp,
    NewRoad,
    TableCycle,
    NewCycle,
    TableZone,
    NewZone,
    TablePeriod,
    NewPeriod,
    TableSocial,
    NewSocial,
    UpdateTimer,
    Welcome,
    Indicator,
    Snackbar,
  },
  data() {
    return {
      newRoadFlag: false,
      newCycleFlag: false,
      newZoneFlag: false,
      newSocialFlag: false,
      newPeriodFlag: false,
      newTimeFlag: false,
      tab: null,
      itemObjct: {},
    }
  },
  async mounted() {
    await this.listTimeConfig()
    await this.listRoad()
    await this.listCycle()
    await this.listSocialGroup()
    await this.listZone()
  },
  methods: {
    ...mapActions([
      'listTimeConfig',
      'listRoad',
      'listCycle',
      'listZone',
      'listPeriod',
      'listSocialGroup',
    ]),
    editItem(param) {
      this.itemObjct = Object.assign({}, param)
      this.newTimeFlag = true
    },
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'isMaster',
      'getUser',
      'getListRoad',
      'getListCycle',
      'getListZone',
      'getListPeriod',
      'getListSocialGroup',
      'getTimerConfig',
      'getAlert',
      'getRol',
      'isRoad',
      'isCycle',
      'isZone',
      'isGroupSocial',
      'isPeriod',
    ]),
  },
}
</script>
<style lang="scss" scoped>
.v-item-group {
  margin: 0 10px;
  overflow: visible;
}
</style>
